import type { ComponentProps } from 'react';

import { cn } from '@/shared/utils/cn';

export interface PageHeaderRootProps extends ComponentProps<'div'> {}

export const PageHeaderRoot = (props: PageHeaderRootProps) => {
  const { className, children, ...rest } = props;

  return (
    <div
      className={cn(
        'relative flex w-full max-w-160 items-center justify-between px-5 pt-[calc(var(--safe-top)+--spacing(3))] pb-3 md:pt-3',
        className,
      )}
      {...rest}
    >
      {children}
    </div>
  );
};
